export enum AccountState {
  PENDING = 'pending',
  REJECTED = 'rejected',
  APPROVED = 'approved',
}
